import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Dna, Stethoscope } from 'lucide-react';

export default function DNATestingTab() {
  return (
              <div className="grid md:grid-cols-2 gap-4">
                <a href="https://embarkvet.com" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
                          <Dna className="w-5 h-5 text-blue-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Embark</h4>
                            <Badge className="bg-green-100 text-green-700 text-xs">270+ Health Risks</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Most comprehensive DNA test - 230,000+ genetic markers, breed + health
                          </p>
                          <p className="text-xs text-primary mt-1">embarkvet.com</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.wisdompanel.com" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center">
                          <Dna className="w-5 h-5 text-purple-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">Wisdom Panel</h4>
                            <Badge className="bg-green-100 text-green-700 text-xs">265+ Conditions</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            99% accuracy - breed identification + health screening for dogs and cats
                          </p>
                          <p className="text-xs text-primary mt-1">wisdompanel.com</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://mydogdna.com" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
                          <Dna className="w-5 h-5 text-amber-600" />
                        </div>
                        <div className="flex-1">
                          <div className="flex items-center gap-2">
                            <h4 className="font-medium">MyDogDNA</h4>
                            <Badge className="bg-green-100 text-green-700 text-xs">270+ Disorders</Badge>
                          </div>
                          <p className="text-sm text-muted-foreground">
                            Genetic disorder screening especially relevant for specific breeds
                          </p>
                          <p className="text-xs text-primary mt-1">mydogdna.com</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
                
                <a href="https://www.penngen.com" target="_blank" rel="noopener noreferrer" className="block">
                  <Card className="h-full card-interactive hover:border-primary">
                    <CardContent className="p-4">
                      <div className="flex items-start gap-3">
                        <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center">
                          <Stethoscope className="w-5 h-5 text-red-600" />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-medium">PennGen</h4>
                          <p className="text-sm text-muted-foreground">
                            University of Pennsylvania - clinical genetic disease tests for veterinarians
                          </p>
                          <p className="text-xs text-primary mt-1">penngen.com</p>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
              </div>
  );
}
